module.exports = __webpack_public_path__ + "media/images/vp/icon.edit.black-94d12096eb02e69054ff51359dcbff25.svg";